import FormViewer from './_src/formViewer.vue'
import FormWraper from './_src/formWraper.vue'
import FormItem from './_src/formItem.vue'
import FormPrinter from './_src/formPrinter.vue'
import FormLabel from './_src/formLabel.vue'
FormViewer.install = function(Vue) {
  Vue.component(FormViewer.name, FormViewer)
  Vue.component(FormWraper.name, FormWraper)
  Vue.component(FormItem.name, FormItem)
  Vue.component(FormPrinter.name, FormPrinter)
  Vue.component(FormLabel.name, FormLabel)
}

export default FormViewer